import { render, staticRenderFns } from "./PolymerTypeList.vue?vue&type=template&id=dd0fc238&"
import script from "./PolymerTypeList.vue?vue&type=script&lang=js&"
export * from "./PolymerTypeList.vue?vue&type=script&lang=js&"
import style0 from "./PolymerTypeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports